<div class="news-banner flex">
  <div class="w-6">
    <img class="w-full h-full object-contain block" [src]="newsBannerData().imagePath" alt="banner-image" />
  </div>
  <div class="w-6 flex">
    <div class="w-97 h-full flex justify-content-around align-items-center">
      <div class="p-4 flex flex-column">
        <div class="primary-text">{{ newsBannerData().mainText }}</div>
        <div class="secondary-text">{{ newsBannerData().secondaryText }}</div>
      </div>
      <geaui-button-v3
        class="checkout-btn"
        [postIcon]="true"
        [flex]="true"
        (click)="goToCheckoutLink(newsBannerData().checkoutLink)"
        >Check out</geaui-button-v3
      >
    </div>
    <div class="w-3 flex justify-content-end">
      <geaui-icon-v3 class="p-2" [file]="'16px_close'" [clickable]="true" (click)="closeNewsBanner()"> </geaui-icon-v3>
    </div>
  </div>
</div>
